import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Plan } from 'src/app/models/plan.model';
import { ChipModule } from 'primeng/chip';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { TagModule } from 'primeng/tag';
import { SelectModule } from 'primeng/select';

@Component({
    selector: 'app-plan-group',
    imports: [
      SelectModule, 
      ChipModule, 
      ButtonModule, 
      FormsModule,
      CommonModule,
      CardModule,
      TagModule
    ],
    template: `

<p-card [style]="{ overflow: 'hidden' }">
    <ng-template #header>
        <img [src]="getBestImage()" alt="Image" class="w-full">
    </ng-template>
    <ng-template #title> <div class="flex justify-content-between">
            <span class="block font-bold text-lg text-blue-600 mb-2">{{selectedPlan && locked ? selectedPlan.PlanName :
                group.Family}}</span>
            <span *ngIf="!locked" class="block font-bold mb-2"
                style="margin-left: auto;">{{getSizeRange()}}<small> sf</small></span>
        </div> </ng-template>
    <!-- <ng-template #subtitle> {{getSizeRange()}}<small> sf</small> </ng-template> -->
    <!-- <div class="p-0" style="display: flex; flex-direction: column; height: 100%;"> -->
    <div class="flex flex-col gap-1">

        <!-- <div *ngIf="this.locked && this.getUniqueSizes().length > 1" class="flex flex-column gap-2">
            <label for="username">Size</label>
            <p-select size="small" [options]="getUniqueSizes()" [(ngModel)]="selectedSize" (onChange)="setSize($event.value)"
                placeholder="Select a Size" class="w-full"/>
        </div> -->
        <div class="grid grid-cols-12 gap-2" *ngIf="this.locked && this.getUniqueSizes().length > 1">
        <label  class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Size</label>
        <div class="col-span-12 md:col-span-9 ml-2">
            <div class="text-900 w-full">
            <p-select size="small" [options]="getUniqueSizes()" [(ngModel)]="selectedSize" (onChange)="setSize($event.value)"
                placeholder="Select a Size" class="w-full" appendTo="body"/>
              </div>
        </div>
        </div>
        <!-- <div *ngIf="this.locked && this.getUniqueSuffixes().length > 1" class="flex flex-column gap-2">
            <label for="username">Variant</label>
            <p-select size="small" [options]="getUniqueSuffixes()" [(ngModel)]="selectedSuffix"
                (onChange)="setSuffix($event.value)" placeholder="Select a Variant" />
        </div> -->
        <div class="grid grid-cols-12 gap-2" *ngIf="this.locked && this.getUniqueSuffixes().length > 1">
        <label  class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Variant</label>
        <div class="col-span-12 md:col-span-9 ml-2">
            <div class="text-900 w-full">
            <p-select size="small" [options]="getUniqueSuffixes()" [(ngModel)]="selectedSuffix"
                (onChange)="setSuffix($event.value)" placeholder="Select a Variant" class="w-full" appendTo="body"/>
              </div>
        </div>
        </div>

        <div class="grid grid-cols-12 gap-2" *ngIf="this.locked && this.getUniqueStyles().length > 1">
        <label  class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Style</label>
        <div class="col-span-12 md:col-span-9 ml-2">
            <div class="text-900 w-full">
            <p-select size="small" [options]="getUniqueStyles()" [(ngModel)]="selectedStyle" (onChange)="setStyle($event.value)"
            placeholder="Select a Style" class="w-full" appendTo="body"/>
              </div>
        </div>
    </div>
        <!-- <div *ngIf="this.locked && this.getUniqueStyles().length > 1" class="flex flex-column gap-2 mb-2">
            <label for="username">Style</label>
            <p-select size="small" [options]="getUniqueStyles()" [(ngModel)]="selectedStyle" (onChange)="setStyle($event.value)"
                placeholder="Select a Style" />
        </div> -->

        <div *ngIf="!this.locked" class="flex w-full flex-wrap gap-1 mt-0">
        <p-tag *ngFor="let style of getUniqueStyles()" severity="secondary" [value]="style" />
            <!-- <p-chip *ngFor="let style of getUniqueStyles()">
                <div class="p-1 text-xs font-bold">{{style}}</div>
            </p-chip> -->
        </div>
        <!-- <div class="flex flex-column justify-content-end" style="display: flex; flex-direction: column;">
            <p *ngIf="!locked" class="font-semibold text-xl text-900 mt-0 mb-2">{{getPriceRange()}}</p>
            <p *ngIf="locked && selectedPlan" class="font-semibold text-xl text-900 mt-0 mb-2">
                {{selectedPlan.PlanPrices?.[0]?.BasePrice | currency:'USD'}}</p>
            <p-button *ngIf="!locked" [styleClass]="'w-full'" label="Configure" [text]="true" [raised]="true"
                (onClick)="selectGroup()" />
            <p-button *ngIf="locked" [styleClass]="'w-full'" [disabled]="!selectedPlan" label="Select"
                severity="success" [text]="true" [raised]="true" (onClick)="onSelectPlan()" />
        </div> -->
    </div>  
    <ng-template #footer>
         <div class="flex flex-column justify-content-end" style="display: flex; flex-direction: column;">
            <p *ngIf="!locked" class="font-semibold text-xl text-900 mt-0 mb-2">{{getPriceRange()}}</p>
            <p *ngIf="locked && selectedPlan" class="font-semibold text-xl text-900 mt-0 mb-2">
                {{selectedPlan.PlanPrices?.[0]?.BasePrice | currency:'USD'}}</p>
            <p-button *ngIf="!locked" [styleClass]="'w-full'" label="Configure" [text]="true" [raised]="true"
                (onClick)="selectGroup()" />
            <p-button *ngIf="locked" [styleClass]="'w-full'" [disabled]="!selectedPlan" label="Select"
                severity="success" [text]="true" [raised]="true" (onClick)="onSelectPlan()" />
        </div>
    </ng-template>
</p-card>


  <!-- <div class="shadow-2 border-round h-full card">
    <div class="relative p-0 m-0">
        <img [src]="getBestImage()" alt="Image" class="block w-full border-round-top p-0 m-0"
            style="height: 10rem; object-fit: cover;">
        <p class="absolute px-2 py-1 border-round-lg text-sm font-normal text-white mt-0 mb-0"
            style="background-color: rgba(78, 78, 78, 0.374); backdrop-filter: blur(10px); top: 3%; left: 3%;">
            {{group.Plans[0].Collection}}</p>
    </div>
    <div class="p-4" style="display: flex; flex-direction: column; height: 100%;">
        <div class="flex justify-content-between">
            <span class="block font-bold text-lg text-blue-600 mb-2">{{selectedPlan && locked ? selectedPlan.PlanName :
                group.Family}}</span>
            <span *ngIf="!locked" class="block font-bold mb-2"
                style="margin-left: auto;">{{getSizeRange()}}<small>sf</small></span>
        </div>

        <div *ngIf="this.locked && this.getUniqueSizes().length > 1" class="flex flex-column gap-2">
            <label for="username">Size</label>
            <p-select size="small" [options]="getUniqueSizes()" [(ngModel)]="selectedSize" (onChange)="setSize($event.value)"
                placeholder="Select a Size" />
        </div>
        <div *ngIf="this.locked && this.getUniqueSuffixes().length > 1" class="flex flex-column gap-2">
            <label for="username">Variant</label>
            <p-select size="small" [options]="getUniqueSuffixes()" [(ngModel)]="selectedSuffix"
                (onChange)="setSuffix($event.value)" placeholder="Select a Variant" />
        </div>
        <div *ngIf="this.locked && this.getUniqueStyles().length > 1" class="flex flex-column gap-2 mb-2">
            <label for="username">Style</label>
            <p-select size="small" [options]="getUniqueStyles()" [(ngModel)]="selectedStyle" (onChange)="setStyle($event.value)"
                placeholder="Select a Style" />
        </div>

        <div *ngIf="!this.locked" class="flex w-full flex-wrap gap-1 mt-0">
        <p-tag *ngFor="let style of getUniqueStyles()" severity="secondary" [value]="style" />
        </div>
        <div class="flex flex-column justify-content-end" style="display: flex; flex-direction: column;">
            <p *ngIf="!locked" class="font-semibold text-xl text-900 mt-0 mb-2">{{getPriceRange()}}</p>
            <p *ngIf="locked && selectedPlan" class="font-semibold text-xl text-900 mt-0 mb-2">
                {{selectedPlan.PlanPrices?.[0]?.BasePrice | currency:'USD'}}</p>
            <p-button *ngIf="!locked" [styleClass]="'w-full'" label="Configure" [text]="true" [raised]="true"
                (onClick)="selectGroup()" />
            <p-button *ngIf="locked" [styleClass]="'w-full'" [disabled]="!selectedPlan" label="Select"
                severity="success" [text]="true" [raised]="true" (onClick)="onSelectPlan()" />
        </div>
    </div>
</div> -->
    `,
    styles: `
    .thumbnail-container {
    width: 400px;
    height: 100%;
    overflow: hidden;
}

.thumbnail-image {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
}
    `
})
export class PlanGroupComponent {
  @Input() group!: { Family: string, Plans: Plan[] }
  @Input() locked: boolean = false;
  @Output() select = new EventEmitter<void>();
  @Output() selectPlan = new EventEmitter<Plan>();

  defaultImage = '';

  selectedSize: number | null = null;
  selectedSuffix: string | null = null;
  selectedStyle: string | null = null;
  selectedPlan: Plan | null = null;

  selectGroup(): void {
        this.select.emit();
        this.resetDefaults();
        console.log(this.group)
  }
  
  getBestImage() {
    if(this.selectedPlan) {
      return this.selectedPlan.Thumb || this.defaultImage;
    }
    return this.group.Plans.find(p => p.Thumb !== null && p.Thumb !== undefined)?.Thumb || this.defaultImage;
}

getPriceRange() {
  const prices = this.group.Plans
    .map(p => p.PlanPrices?.map(pp => pp.BasePrice))
    .flat()
    .filter((price): price is number => price !== null && price !== undefined);

  if (prices.length === 0) {
    return 'No prices available';
  }

  const minPrice = Math.min(...prices);
  const maxPrice = Math.max(...prices);

  return `$${minPrice.toLocaleString()} - ${maxPrice.toLocaleString()}`;
}

getSizeRange() {
  const sizes = this.group.Plans
    .map(p => p.Size)
    .filter((size): size is number => size !== null && size !== undefined);

  if (sizes.length === 0) {
    return 'No sizes available';
  }

  const minSize = Math.min(...sizes);
  const maxSize = Math.max(...sizes);

  if(minSize === maxSize) {
    return `${minSize}`;
  }
else {
  return `${minSize} - ${maxSize}`;
}
}

getUniqueStyles() {
  const styles = this.group.Plans
    .map(p => p.Styles?.StyleName)
    .filter((style, index, self) => style && self.indexOf(style) === index);

  // Sort styles by length
  const sortedStyles = styles.sort((a, b) => (a || '').length - (b || '').length);

  // Alternate between shortest and longest
  const arrangedStyles = [];
  let i = 0, j = sortedStyles.length - 1;
  while (i <= j) {
    if (i === j) {
      arrangedStyles.push(sortedStyles[i]);
    } else {
      arrangedStyles.push(sortedStyles[i], sortedStyles[j]);
    }
    i++;
    j--;
  }

  return arrangedStyles || null;
}

onSelectPlan() {
  if(this.selectedPlan) {
    this.selectPlan.emit(this.selectedPlan);
  }
}

getUniqueSizes() {
  const sizes = this.group.Plans
    .map(p => p.Size)
    .filter((size, index, self) => self.indexOf(size) === index);
  return sizes;
}

getUniqueSuffixes() {
  const suffixes = this.group.Plans
    .map(p => p.Suffix)
    .filter((suffix, index, self) => suffix && self.indexOf(suffix) === index);
  return suffixes;
}

resetDefaults() {
  if(this.getUniqueSizes().length === 1) {
  this.setSize(this.getUniqueSizes()[0])
  }
  if(this.getUniqueSuffixes() && this.getUniqueSuffixes().length === 1) {
    this.setSuffix(this.getUniqueSuffixes()[0])
  }
  if(this.getUniqueStyles() && this.getUniqueStyles().length === 1) {
    this.setStyle(this.getUniqueStyles()[0] || null)
  }
}

setPlan() {
  const filteredPlans = this.group.Plans.filter(plan => {
    const matchesStyle = this.selectedStyle ? plan.Styles?.StyleName === this.selectedStyle : true;
    const matchesSuffix = this.selectedSuffix ? plan.Suffix === this.selectedSuffix : true;
    const matchesSize = this.selectedSize ? plan.Size === this.selectedSize : true;
    return matchesStyle && matchesSuffix && matchesSize;
  });

  if (filteredPlans.length === 1) {
    this.selectedPlan = filteredPlans[0];
  } else if (!this.selectedStyle && !this.selectedSuffix && !this.selectedSize && this.group.Plans.length === 1) {
    this.selectedPlan = this.group.Plans[0];
  } else {
    this.selectedPlan = null;
  }
  console.log(this.selectedPlan)
}

setStyle(style: string | null) {
  this.selectedStyle = style;
  this.setPlan();
}

setSuffix(suffix: string | null) {
  this.selectedSuffix = suffix;
  this.setPlan();
}

setSize(size: number | null) {
  this.selectedSize = size;
  this.setPlan();
}

}
